<div class="Bcc">
  <div *ngIf="sessionData" class="BccManage">
    <div class="BccManage-header mb-3 d-flex flex-row justify-content-between">
      <h4 class="title__page">
        You can set or update Blind Carbon Copy for {{ type }} Emails
      </h4>
      <app-button
        text="Back to Inbox"
        color="blue"
        size="small"
        route="/messages"
        [style]="'outline'"></app-button>
    </div>
  </div>
  <div *ngIf="formReady" class="BccManage-form">
    <form [formGroup]="formGroup">
      <div class="BccManage-form-row">
        <div class="BccManage-form-label">
          <p class="mb-0">Bcc email address:</p>
        </div>
        <div class="col col-12">
          <app-text-field
            placeholder="Email"
            formControlName="email"></app-text-field>
        </div>
      </div>
      <div class="BccManage-form-buttons mt-3">
        <app-button
          class="BccManage-form-button"
          [style]="cancelButtonProperties.style"
          [size]="cancelButtonProperties.size"
          [color]="cancelButtonProperties.color"
          [route]="cancelButtonProperties.route"
          [text]="cancelButtonProperties.text"></app-button>
        <app-button
          *ngIf="type !== 'all'"
          class="BccManage-form-button"
          [style]="removeButtonProperties.style"
          [size]="removeButtonProperties.size"
          [color]="removeButtonProperties.color"
          [text]="removeButtonProperties.text"
          [Click]="removeButtonProperties.onClick"></app-button>
        <app-button
          class="BccManage-form-button"
          [style]="updateButtonProperties.style"
          [size]="updateButtonProperties.size"
          [color]="updateButtonProperties.color"
          [text]="updateButtonProperties.text"
          [Click]="updateButtonProperties.onClick"></app-button>
      </div>
    </form>
  </div>
</div>
